import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import { DashboardMain, DashboardEmpty } from '../../components/';
import {
  createNewProject,
  selectProject,
  selectProjectRequest,
  discardProject,
  fetchUserProjects,
} from '../../store/actions/Dashboard';
import { routesAction } from '../../shared/helpers';
import { setProject } from '../../store/actions/ProjectView';

const filters = {
  byStatus: (p, status) => p.status === status,
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.handleCreateProject = this.handleCreateProject.bind(this);
    this.handleSelectProject = this.handleSelectProject.bind(this);
    this.handleDiscardProject = this.handleDiscardProject.bind(this);
    this.handleGoToProjectView = this.handleGoToProjectView.bind(this);
    this.hasPendingDrafts = this.hasPendingDrafts.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.currentProject !== nextProps.currentProject &&
      nextProps.currentProject
    ) {
      this.props.history.push(
        routesAction.onboarding(nextProps.currentProject),
      );
    }
  }

  componentDidMount() {
    this.props.dispatchSelectProject();
    this.props.dispatchFetchUserProjects();
  }

  handleCreateProject() {
    const {
      history: { push },
      dispatchCreateNewProject,
    } = this.props;

    dispatchCreateNewProject(this.props.loggedUserEmail).then(action => {
      if (action.type === 'SELECT_PROJECT') {
        push(routesAction.onboarding(action.payload.project_id));
      }
    });
  }

  handleDiscardProject(project) {
    this.props.dispatchDiscardProject(project);
  }

  handleSelectProject(projectId, selectedProject) {
    this.props.dispatchSelectProject(projectId, selectedProject);
  }

  handleGoToProjectView(project) {
    const {
      dispatchSetProject,
      history: { push },
    } = this.props;

    dispatchSetProject(project);
    push(routesAction.project(project.id));
  }

  hasPendingDrafts(drafts = []) {
    if (!drafts.length) {
      return true;
    }
    return drafts.filter(d => d.status !== 'submitted').length;
  }

  render() {
    const {
      projects,
      overviewSteps,
      isFetchingProjects,
      user,
      isReset,
    } = this.props;

    const orderedProjects = orderBy(
      projects,
      [p => moment(p.updated_at).format('x')],
      ['desc'],
    );

    const unsubmittedProjects = orderedProjects.filter(
      p => p.status === 'unsubmitted',
    );

    const activeProjects = orderedProjects.filter(
      p => filters.byStatus(p, 'active') && this.hasPendingDrafts(p.drafts),
    );

    const pendingProjects = orderedProjects.filter(p =>
      filters.byStatus(p, 'pending'),
    );

    const pastProjects = orderedProjects.filter(
      p =>
        ['past', 'rejected'].includes(p.status) ||
        !this.hasPendingDrafts(p.drafts),
    );

    return !isFetchingProjects ? (
      <Fragment>
        {projects.length ? (
          <DashboardMain
            isReset={isReset}
            unsubmittedProjects={unsubmittedProjects}
            activeProjects={activeProjects}
            pendingProjects={pendingProjects}
            pastProjects={pastProjects}
            handleCreateProject={this.handleCreateProject}
            handleSelectProject={this.handleSelectProject}
            handleDiscardProject={this.handleDiscardProject}
            overviewSteps={overviewSteps}
            handleGoToProjectView={this.handleGoToProjectView}
            isEmptyProjects={isEmpty(projects)}
            user={user}
          />
        ) : (
          <DashboardEmpty />
        )}
      </Fragment>
    ) : null;
  }
}

const mapStateToProps = state => ({
  currentProject: state.dashboard.currentProject,
  isFetchingProjects: state.dashboard.isFetchingProjects,
  projects: state.dashboard.projects,
  loggedUserEmail: state.authentication.user.email,
  user: state.authentication.user,
  isReset: state.authentication.isReset,
  overviewSteps: state.overview.overviewSteps,
});

const mapDispatchToProps = dispatch => ({
  dispatchCreateNewProject: loggedUser =>
    dispatch(createNewProject(loggedUser)),
  dispatchDiscardProject: project => {
    dispatch(discardProject(project));
  },
  dispatchSelectProject: (projectId, selectedProject) => {
    dispatch(selectProjectRequest());
    dispatch(selectProject(projectId, selectedProject));
  },
  dispatchFetchUserProjects: () => {
    dispatch(fetchUserProjects());
  },
  dispatchSetProject: project => dispatch(setProject(project)),
});

Dashboard.propTypes = {
  history: PropTypes.object,
  projects: PropTypes.array,
  loggedUserEmail: PropTypes.string,
  overviewSteps: PropTypes.array,
  dispatchSetProject: PropTypes.func,
  isFetchingProjects: PropTypes.bool,
  dispatchSelectProject: PropTypes.func,
  dispatchDiscardProject: PropTypes.func,
  dispatchCreateNewProject: PropTypes.func,
  dispatchFetchUserProjects: PropTypes.func,
  user: PropTypes.object.isRequired,
  currentProject: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js